module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("©2012 Sarah Vap")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("No part of this book may be used or reproduced in any manner without written permission except in the case of brief quotations embodied in critical articles and reviews. Please direct inquiries to:")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Saturnalia Books"), _c('br'), _vm._v("105 Woodside Rd."), _c('br'), _vm._v("Ardmore, PA 19003"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:info@saturnaliabooks.com"
    }
  }, [_vm._v("info@saturnaliabooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN: 978-0-9833686-4-9"), _c('br'), _vm._v("Library of Congress Control Number: 2012945504")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Book Design by Saturnalia Books"), _c('br'), _vm._v("Printing by Westcan Printing Group, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover Art: Paul Koundounaris"), _c('br'), _vm._v("Distributed by:"), _c('br'), _vm._v("University Press of New England"), _c('br'), _vm._v("1 Court Street"), _c('br'), _vm._v("Lebanon, NH 03766"), _c('br'), _vm._v("800-421-1561")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Grateful acknowledgment is made to the editors and staff of the following journals who published many of these poems, often in very different versions or under different titles: Barrow Street, Bone Bouquet Journal, Caffeine Destiny, Court Green, Ensemble Jourine, Field, Fugue, Interim, La Petite Zine, Locuspoint, Pistola Mag, Skein, Slurve, 42opus.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Thank you to Norman Dubie, Diana Park, Jenny Browne, Mark Irwin, David St. John, Anna Journey. Thank you Sean Nevin, Brian Leary, Henry Israeli, Henry Quintero, Mona Polacca, Forrest Gander, C.D. Wright, Kathy Ossip, Danielle Pafunda. For some language, thank you to Dan Beachy-Quick, Daniel Tiffany, Wade Davis, Dickinson, Baudrillard, Artaud, Levinas, and most certainly others.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("For support, thank you to Arizona State University and University of Southern California, and to P.E.O. Arizona Chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Heartfelt gratitude to Daniel and Jeannie Vargas and Carolina Vargas, to Gonzalo Moscoso Salazar, to Amy Savoie, and to Amir Brito Cadôr and Daniela Maura, who shared their homes and stories with us during our travels, and to Sherwin Bitsui, who wandered with us awhile.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Thank you joyfully, TF, O, M.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 60
// module chunks = 0